import styled from 'styled-components';
import { variant } from 'styled-system';
import { ColorProps, PropsWithPseudo } from '../../../../theme/styledProps';

type ClickableRowVariant = 'default' | 'clickable';

export const TableRow = styled.tr<{
  isExpanded?: boolean;
  variant?: ClickableRowVariant;
}>(
  ({ onClick }) => ({
    ...(onClick
      ? {
          userSelect: 'none',
          tabIndex: 0,
          role: 'button',
          outline: 'none',
          cursor: 'pointer',
        }
      : {}),
  }),

  ({ isExpanded }) =>
    variant<PropsWithPseudo<ColorProps, '&:hover'>, ClickableRowVariant>({
      variants: {
        default: {
          bg: 'bg',

          '&:hover': {
            bg: 'bg',
          },
        },

        clickable: {
          bg: isExpanded ? 'primary.100' : 'bg',

          '&:hover': {
            bg: isExpanded ? 'primary.200' : 'neutral.100',
          },
        },
      },
    }),
);

TableRow.defaultProps = {
  isExpanded: false,
  variant: 'default',
};
